import axiosInstance from '../utils/AxiosConfig';

export const getBatches = async (locationId, page = 1, pageSize = 10, searchTerm = '') => {
  const params = new URLSearchParams({
    locationId: locationId.toString(),
    page: page.toString(),
    pageSize: pageSize.toString()
  });
  
  if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
    params.append('search', searchTerm.trim());
  }
  
  const response = await axiosInstance.get(`/productions?${params}`);
  return response.data.data;
};

export const saveElaboration = async (locationId, request) => {
  const response = await axiosInstance.post('/productions/elaboration', 
    request,
    {
      params: { locationId: locationId }
    }
  );
  return response.data.data;
};

export const savePackaging = async (locationId, request) => {
  const response = await axiosInstance.post('/productions/packaging', 
    request,
    {
      params: { locationId: locationId }
    }
  );
  return response.data.data;
};

export const getProductionById = async (productionId) => {
  const response = await axiosInstance.get(`/productions/${productionId}`);
  return response.data.data;
};

export const getPlantLots = async (locationId, { search = '', status = '', referenceType = '', page = 1, pageSize = 25 } = {}) => {
  const params = { page, pageSize };
  if (search && search.trim()) params.search = search.trim();
  if (status) params.status = status;
  if (referenceType !== '') params.referenceType = referenceType;
  const response = await axiosInstance.get(`/lots/plant/${locationId}`, { params });
  return response.data.data;
};

export const getLotDetail = async (lotId) => {
  const response = await axiosInstance.get(`/lots/detail/${lotId}`);
  return response.data.data;
};

export const updateLot = async (lotId, request) => {
  const response = await axiosInstance.put(`/lots/${lotId}`, request);
  return response.data.data;
};
